export const castPossiblyNullToNumber = (value: string | null) => {
	return value ? +value : 0
}

// Remove all non-digit character
export const toOnlyNumbers = (value: string) => {
	return value.replace(/\D/g, "")
}
